import { createAsyncAction, action } from 'typesafe-actions'
import { Provider, WalkUpPersonDetailsInput } from 'types/global'
import api from 'api/graphql/graphql'
import { MessageTypes } from 'constants/message-screens'
import { withRegLogAsync } from 'modules/reg-logger'
import { ApolloError } from 'apollo-boost'

export const ADD_PERSON_REQUESTED = 'walkUpReg/ADD_PERSON_REQUESTED'
export const ADD_PERSON_COMPLETED = 'walkUpReg/ADD_PERSON_COMPLETED'
export const ADD_PERSON_FAILED = 'walkUpReg/ADD_PERSON_FAILED'

export const SET_ERROR_MSG_TYPE = 'walkUpReg/SET_ERROR_MSG_TYPE'

export const PROVIDERS_REQUESTED = 'walkUpReg/PROVIDERS_REQUESTED'
export const PROVIDERS_COMPLETED = 'walkUpReg/PROVIDERS_COMPLETED'
export const PROVIDERS_FAILED = 'walkUpReg/PROVIDERS_FAILED'

export const setErrorMsgType = (errorMsgType: MessageTypes) =>
  action(SET_ERROR_MSG_TYPE, errorMsgType)

export const requestAddPerson = createAsyncAction(
  ADD_PERSON_REQUESTED,
  ADD_PERSON_COMPLETED,
  ADD_PERSON_FAILED
)<
  void,
  { registrationToken: string; alreadyItfCustomer: boolean; alreadyRegisteredForService: boolean },
  Error
>()

export const addWalkUpPerson = (
  personInput: WalkUpPersonDetailsInput,
  recaptchaInput: { action: string; token: string }
) => {
  return async dispatch => {
    const addAccount = withRegLogAsync(api.addAccount.bind(api), 'addAccount')
    try {
      dispatch(requestAddPerson.request())
      dispatch(requestAddPerson.success(await addAccount(personInput, recaptchaInput)))
    } catch (e) {
      const error = e as ApolloError
      error.message = `Failed to add Person Account: ${error?.message}`
      console.warn(error.message)

      let errorMsgType = MessageTypes.DEFAULT

      if (error?.graphQLErrors && error.graphQLErrors.length) {
        const hasRecaptchaErrors = error.graphQLErrors.some(
          e => e?.extensions?.code === 'RECAPTCHA_REFUSED'
        )
        if (hasRecaptchaErrors) errorMsgType = MessageTypes.RECAPTCHA_VALIDATION_ERROR
      }
      dispatch(setErrorMsgType(errorMsgType))
      dispatch(requestAddPerson.failure(error))
    }
  }
}

export const requestNationalAssociationOptions = createAsyncAction(
  PROVIDERS_REQUESTED,
  PROVIDERS_COMPLETED,
  PROVIDERS_FAILED
)<void, Provider[], Error>()

export const getNationalAssociationOptions = () => {
  return async dispatch => {
    try {
      dispatch(requestNationalAssociationOptions.request())
      dispatch(requestNationalAssociationOptions.success(await api.getProviderNames()))
    } catch (e) {
      console.warn('Failed to get providers', e && (e as Error)?.message)
      dispatch(requestNationalAssociationOptions.failure(e as Error))
    }
  }
}
